import { render, staticRenderFns } from "./DisplayContactAddress.vue?vue&type=template&id=f635f7de&"
import script from "./DisplayContactAddress.vue?vue&type=script&lang=ts&"
export * from "./DisplayContactAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f635f7de')) {
      api.createRecord('f635f7de', component.options)
    } else {
      api.reload('f635f7de', component.options)
    }
    module.hot.accept("./DisplayContactAddress.vue?vue&type=template&id=f635f7de&", function () {
      api.rerender('f635f7de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/DisplayContactAddress.vue"
export default component.exports